module.exports = __webpack_public_path__ + "assets/3.bfe3dece.jpg";